/*Recurso: Users - Servicio de lectura del API: Maneja las notificaciones presentadas en el encabezado del sistema (campana)
  Tareas:
    GetUserAuth   // datos del usuario / Encabezado - Perfil
    SearchUserLDAP  //consulta al LDAP / Configuracion - Alta de usuarios proponentes - Editar - opción Usuarios especificiso - input + botón Buscar
*/

import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL + 'Users/';

//se genera una función por cada tarea del recurso api

    const cargaGetUserAuth = async (token:any) => {
        //console.log ('API: ' + API_URL + 'GetUserAuth',  {headers: { 'content-type': 'text/json', 'Authorization':token  }} )
        return await axios.post(API_URL + 'GetUserAuth/', 'method: post',
            { headers: { 'content-type': 'text/json', 'Authorization':token }} )
        //'method: post', se lo quite para provocar error
    };
    //tarea: SendRateProposal  
     const cargaSearchUserLDAP  = async (token:any, body:any) => {
        //console.log ('***API: ' + API_URL + 'SearchUserLDAP', body,  {headers: { 'content-type': 'text/json' }} )
        return await axios.post(API_URL + 'SearchUserLDAP', body, 
            {headers: { 'content-type': 'text/json', "Authorization":token }} )
    };  

const usersService = {
    cargaGetUserAuth: cargaGetUserAuth,
    cargaSearchUserLDAP:cargaSearchUserLDAP,
};

export default usersService;
